import React from 'react';

import IconPanel from '../IconPanel';

import clockIcon from '../../images/icons/Clock.svg';

const CustomerLinkExpired = (): JSX.Element => (
  <IconPanel
    translationKey='components.Verification.CustomerLinkExpired'
    icon={<img src={clockIcon} alt='' width={62} height={62} />}
    noInfo
    detailsCentered
    data-testid='verification-customer-link-expired'
  />
);

export default CustomerLinkExpired;
